import React, { useEffect, useRef } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './SlTransition.scss';

interface ITransitionData {
	delay?: number;
	duration?: number;
}
interface ISlTransitionProps {
	fadeIn?: ITransitionData;
	fadeOut?: ITransitionData;
	isFadeOutStarted?: boolean;
	style?: React.CSSProperties;
	children?: JSX.Element | JSX.Element[];
}
export function SlTransition({
	fadeIn,
	fadeOut,
	isFadeOutStarted,
	style,
	children,
}: ISlTransitionProps): JSX.Element {
	useStyles(s);
	const wrapper = useRef<HTMLDivElement>(null);
	const content = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const wrapperStyle: React.CSSProperties = fadeIn
			? {
				animationName: 'fadeIn',
				animationTimingFunction: 'linear',
				animationFillMode: 'forwards',
				animationDelay: `${fadeIn.delay || 0}s`,
				animationDuration: `${fadeIn.duration || 0}s`,
			}
			: {
				opacity: 1,
			};
		Object.assign(wrapper.current.style, wrapperStyle);
	}, []);

	useEffect(() => {
		if (isFadeOutStarted && fadeOut) {
			const contentStyle: React.CSSProperties = {
				animationName: 'fadeOut',
				animationTimingFunction: 'linear',
				animationFillMode: 'forwards',
				animationDelay: `${fadeOut.delay || 0}s`,
				animationDuration: `${fadeOut.duration || 0}s`,
			};
			Object.assign(content.current.style, contentStyle);
		}
	}, [isFadeOutStarted]);

	return (
		<div ref={wrapper} style={{ opacity: 0, ...style }}>
			<div ref={content} style={style}>
				{children}
			</div>
		</div>
	);
}
